/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import City from './City/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address/NewAddress/Content/Fields"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-2tX3iC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 style={{'--pr-2-2tX3iC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
</div>
<div
  data-testid="Fields.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<City
  viewPath={`${viewPath}/City`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
</div>
{children}
</React.Fragment>)
}